import React, { useState } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";


const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "#142512",
    color: "black", 
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1, 4),
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));
function getRandomString(length) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}
const SendLogsButton = () => {
  const classes = useStyles();
   const [randomKey, setRandomKey] = useState("");
  
  const api= localStorage.getItem("api");
  let emmsKey="";
  let elmKey="";
  const headers = useSelector((state) => state.header);
  const curremms =useSelector((state)=>state.curremms)
  const selectedOption = curremms?.curremms?.id;
  
  const emmsheaders=useSelector((state)=>state.emmsheader);
  const handleClick = () => {
  const generatedKey = getRandomString(6);
    
    
    elmKey= `ELM- ${generatedKey}`;
    emmsKey=`EMMS- ${generatedKey}`;
    setRandomKey(elmKey);

    const requestBody = {
      id: elmKey,
    };
    axios
      .post(api + `/logs`, requestBody, headers)
      .then((response) => {
         
      })
      .catch((error) => {
        toast.error(error.message);
        console.error(error);
        
      });

      const requestbody ={
        path: "logs",
        query: {},
        emmsId: selectedOption,
        body: {  "id": emmsKey},
        requestType: "POST",
        headers: emmsheaders?.emmsheaders?.headers,
      }
      
      axios
        .post(api+`/emms/piggyback`,requestbody, headers)
        .then(() => {
           console.log("EMMS Logs sent succesfully")
        })
        .catch((error) => {
          console.error(error);
          
        })

     
  };

  return (
    <div>
      <Button
        style={{ marginTop: "3.5%", textTransform: "none" }}
        variant="outlined"
        className={classes.button}
        onClick={handleClick}
      >
        Send Logs to Support
      </Button>

      {randomKey && (
        <div style={{ margin: "5%", color: "green" }}>
          Logs sent to the Support Desk with ID: <br/> 
           {randomKey}. <br/> Please share this
          ID with your support executive.
        </div>
      )}
    </div>
  );
};

export default SendLogsButton;
